import { Star } from "lucide-react";
import { SectionHeader } from "../section-header";
import { Stats } from "../stats";

interface RatingsStatsProps {
  averageRating: number;
  match: {
    response: string;
    createdAt: string;
  };
  continueFeedback: {
    response: string;
    createdAt: string;
  };
}

export function RatingsStats({
  averageRating,
  match,
  continueFeedback,
}: RatingsStatsProps) {
  const stats = [
    {
      label: "Mentorship",
      value: averageRating?.toFixed(2) || "-",
    },
    {
      label: "Match",
      value: match?.response || "-",
      date: match?.createdAt,
    },
    {
      label: "Continue",
      value: continueFeedback?.response ?? "-",
      date: continueFeedback?.createdAt,
    },
  ];

  return (
    <>
      <SectionHeader
        icon={<Star className="h-6 w-6 text-zinc-700" />}
        title="Ratings"
      />
      <Stats stats={stats} />
    </>
  );
}
